import angular from "angular";
import core from "../../core/core.module";

let mod = angular
    .module('DirectionsControl.form', [core])
    .component('directionForm', {
        controller: ['Data', '$http', 'notifier', controller],
        template: require('./direction-form.html'),
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller(Data, $http, notifier) {

    let $ctrl = this;

    $ctrl.id = null;
    $ctrl.startStation = null;
    $ctrl.endStation = null;
    $ctrl.hasDirectRoute = false;

    $ctrl.$onInit = function () {
        if ($ctrl.resolve.direction) {
            let d = $ctrl.resolve.direction;
            $ctrl.id = d.id;
            $ctrl.startStation = {
                code: d.start_station.StationCode,
                name: d.start_station.StationNameFull,
            };
            $ctrl.endStation = {
                code: d.end_station.StationCode,
                name: d.end_station.StationNameFull
            };
            $ctrl.hasDirectRoute = d.has_direct_route;
        }
    };

    $ctrl.searchStations = function (fragment) {
        return Data.getStations(fragment);
    };

    $ctrl.submit = function () {

        let defer;

        let params = {
            start_station: $ctrl.startStation.code,
            end_station: $ctrl.endStation.code,
            has_direct_route: $ctrl.hasDirectRoute
        };

        if ($ctrl.id) {
            params['_method'] = 'PUT';
            defer = $http.post(`/control-panel/directions/${$ctrl.id}`, params);
        } else {
            defer = $http.post('/control-panel/directions', params);
        }

        defer.then(
            function (response) {
                $ctrl.close({
                    $value: {
                        id: $ctrl.id || response.data.id,
                        start_station: {
                            StationCode: $ctrl.startStation.code,
                            StationNameFull: $ctrl.startStation.name
                        },
                        end_station: {
                            StationCode: $ctrl.endStation.code,
                            StationNameFull: $ctrl.endStation.name
                        },
                        has_direct_route: $ctrl.hasDirectRoute,
                        options_count: $ctrl.resolve.direction ? $ctrl.resolve.direction.options_count : 0,
                    }
                })
            },
            function (error) {
                notifier.errorResponseNotify(error);
            }
        );
    };

}

export default mod.name;


// WEBPACK FOOTER //
// ./resources/assets/modules/directions-control/direction-form/direction-form.js